import { render, staticRenderFns } from "./statementContent.vue?vue&type=template&id=52994300&scoped=true"
import script from "./statementContent.vue?vue&type=script&lang=js"
export * from "./statementContent.vue?vue&type=script&lang=js"
import style0 from "./statementContent.vue?vue&type=style&index=0&id=52994300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52994300",
  null
  
)

export default component.exports